import React from 'react'
import isEqual from 'lodash.isequal'
import { DetailInfo } from '@softwaredev_cegeka/stix-form'
import { Tabs } from '@softwaredev_cegeka/stix-core'
import BaseSearchableList from 'src/components/SearchableList'
import { AuthApi } from 'src/api/authApi'
import { authenticatedUserStore } from 'src/stores'

const APPLICATION_TAB_MAPPINGS = {
    SERVICE_ACTIONS_TAB: {
        entityName: 'service',
        dataField: 'actions',
        itemId: 'service',
        itemDisplay: item =>
            `${item.service_namespace}:${item.category}:${item.key}`,
        detailItemDisplay: item => item.description,
        selectDisplay: item =>
            `${item.service_namespace}:${item.category}:${item.key}`,
    },
}

/**
 * Application Drawer content
 * @returns {*[]}
 */
export default class ApplicationDrawerContent extends React.Component {
    state = {
        loading: false,
        applicationActions: {
            actions: [],
        },
    }

    authClient = new AuthApi(authenticatedUserStore.authToken)

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(prevProps.application, this.props.application)) {
            this.getApplicationActions()
        }
    }

    componentWillUnmount() {
        this.authClient.cancelRequest()
    }

    getApplicationActions = () => {
        const { application } = this.props
        this.setState(
            {
                loading: true,
            },
            () => {
                this.authClient
                    .fetchApplicationServiceActions(application.id, 1, 20, {
                        load_relationships: true,
                        sort: '+category',
                    })
                    .then(response => {
                        this.setState({
                            applicationActions: {
                                actions: response?.data?.results,
                            },
                            loading: false,
                        })
                    })
                    .catch(err => {
                        this.setState({
                            loading: false,
                        })
                    })
            }
        )
    }

    render() {
        const { application } = this.props
        const content = [
            {
                label: 'Key',
                value: application.key,
            },
            {
                label: 'Contact Email',
                value: application.contact_email,
            },
            {
                label: 'Description',
                value: application.description,
            },
        ]
        return (
            <>
                <DetailInfo data={content} />
                <Tabs
                    variant="material"
                    defaultActiveKey="service_actions"
                    id="uncontrolled-tab-example"
                >
                    <Tabs.Pane
                        eventKey="service_actions"
                        title="Service actions"
                    >
                        <BaseSearchableList
                            data={this.state.applicationActions}
                            type={APPLICATION_TAB_MAPPINGS.SERVICE_ACTIONS_TAB}
                            filteredEntitiesUrl={
                                '/api/auth/applications' + application.id
                            }
                            emptyListMessage={`No ${APPLICATION_TAB_MAPPINGS.SERVICE_ACTIONS_TAB.entityName} linked to this application.`}
                            sortParam={{ sort: '+name' }}
                            disableRemoveButton
                            loading={this.state.loading}
                            addEntityUrl={'/application-form/' + application.id}
                        />
                    </Tabs.Pane>
                </Tabs>
            </>
        )
    }
}
